import React from "react";
import "./index.css";

import ContentBox from "../ContentBox";

/*
    To change the events list, edit the list below.
    You may add a new event, or remove or alter an existing event.
    Note that every event is inside brackets { ... }.
    Also note where there are commas. These are important. So are the double-quotes.
    To create a new category, simply make a new entry with a different "day" value.
    Events with identical "day" values will be presented together.
    "Day" is only an arbitrary name. You could add time or something different altogehter
    that has nothing to do with an actual day. Just know that different values will be presented separately.
*/
const events = [
  {
    name: "Squad Server Seeding",
    day: "Every Day - 15:00 GMT",
  },
  {
    name: "Funday Friday - Community Games",
    day: "Fridays - Weekly | 19:00 GMT",
  },
  {
    name: "Helldivers II Game Night",
    day: "Saturdays - Weekly | 19:00 GMT"
  },
  {
    name: "Squad Shenanigans Game Night",
    day: "Saturdays - Weekly | 19:00 GMT"
  },
  {
    name: "Enlisted Game Night",
    day: "Saturdays - Weekly | 19:00 GMT"
  },
  {
    name: "Enlisted Clan War Training Night",
    day: "Saturdays - Weekly | 19:00 GMT"
  },
  {
    name: "Enlisted Clan Wars Night",
    day: "Saturdays - Dependant | 19:00 GMT"
  },
  {
    name: "Open Community Game Night",
    day: "Sundays - Weekly | 19:00 GMT"
  },
];

const Events = () => {
  // This groups the events by day so that they are displayed together.
  const organizeEventsByDay = (eventsArray) => {
    return eventsArray.reduce((organized, event) => {
      const day = event.day;
      if (!organized[day]) {
        organized[day] = [];
      }
      organized[day].push(event);
      return organized;
    }, {});
  };

  const eventsByDay = organizeEventsByDay(events);
  const eventsByDayArray = Object.entries(eventsByDay).map(
    ([day, dayEvents]) => ({
      day: day,
      events: dayEvents.map((event) => event.name),
    })
  );

  // You can change the header="Events" here if you want a different title.
  // You'll probably never need to touch the rest.
  return (
    <ContentBox header="Events">
      <div className="events-box">
        {eventsByDayArray.map(({ day, events }) => (
          <div key={day} className="event-day">
            <div className="event-day-title">{day}</div>
            <div className="event-day-events">
              {events.map((eventName) => (
                <div key={eventName}>{eventName}</div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </ContentBox>
  );
};

export default Events;
